import '@/assets/css/style.css'

import '@/assets/vendor/purecounter/purecounter.js'

import 'aos/dist/aos.js'
import 'aos/dist/aos.css'

import '@/assets/vendor/glightbox/js/glightbox.min.js'
import '@/assets/vendor/glightbox/css/glightbox.min.css'

import '@/assets/vendor/swiper/swiper-bundle.min.js'
import '@/assets/vendor/swiper/swiper-bundle.min.css'

import '@/assets/vendor/bootstrap/css/bootstrap.min.css'
import '@/assets/vendor/bootstrap-icons/bootstrap-icons.css'

import '@/assets/vendor/isotope-layout/isotope.pkgd.min.js'
import '@/assets/vendor/php-email-form/validate.js'
import '@/assets/vendor/boxicons/css/boxicons.min.css'

import '@/assets/js/main.js'
import {i18n} from '@/assets/js/i18n.js'
import {createApp} from 'vue'
import {createHead} from '@vueuse/head';
import App from './App.vue'

const app = createApp(App);
app.use(i18n)
app.use(createHead());
app.mount('#app');
